<template>
  <div class="mb-4">
    <validation-observer ref="mcObserver" v-slot="{ errors }">
      <validation-provider :rules="{ required: !isOptional, requiredOptionText: {question, stateResponseTextValue} }" :disabled="isOptional" :immediate="validateImmediate">
        <div v-for="(error, name) in errors" :key="name">
          <h6 v-if="displayError(error, number + question.questionText)" class="text-danger">{{ error[0] }}</h6>
        </div>
        <div :style="{ 'background-color': questionBackColor }"><span v-html="number" class="number-text"></span><span v-html="question.questionText"></span></div>
        <div v-html="question.instructions" class="font-italic"></div>
        <div v-if="debugQuestions" class="text-warning">{{ question.hspCategoryQuestionId }} (state: {{ stateResponseId }}, text: {{ stateResponseTextValue }})</div>
        <div :style="{ 'background-color': responsesBackColor }">
          <div v-for="response in responses" :key="response.hspResponseId">
            <base-radio
              :name="response.hspResponseId"
              :value="stateResponseId"
              :textValue="stateResponseTextValue"
              :isDarkMode="isDarkMode"
              :isDesktop="isDesktop"
              @input="handleInput"><span v-html="response.responseTitle"></span></base-radio>
            <div class="mt-1" v-if="response.hspResponseTypeId == 2">
              <base-input 
                v-model="textModel" 
                :disabled="disable(response.hspResponseId)"
                :hideValue="disable(response.hspResponseId)"
              ></base-input>
            </div>
            <div class="mt-1" v-else-if="response.hspResponseTypeId == 3">
              <base-input 
                v-model="textModel" 
                :disabled="disable(response.hspResponseId)" 
                :hideValue="disable(response.hspResponseId)"
                :isMultiline="true"
              ></base-input>
            </div>
          </div>
        </div>
      </validation-provider>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapGetters } from 'vuex';
import { getResponses, isDesktopSize } from 'src/modules/utils';

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    question: {
      type: Object,
      required: true,
      default: function() {
        return {
          responses: []
        }
      }
    },
    number: String,
    questionBackColor: String,
    responsesBackColor: String,
    sectionId: {
      type: Number,
      required: true,
      description: 'Needed to disable validation when section is not active.'
    },
    validateImmediate: Boolean,
    isDarkMode: Boolean,
  },
  data() {
    return {
      responses: []
    }
  },
  computed: {
    ...mapGetters(['windowWidth', 'activeSectionId', 'debugQuestions']),
    isDesktop() {
      return isDesktopSize(this.windowWidth);
    },
    isDisplayed() {
      return this.sectionId === this.activeSectionId;
    },
    isOptional() {
      if(this.isDisplayed && this.question.isRequired === true) {
        return false;
      }

      return true;
    },
    stateResponseId() {
      return this.$store.getters.getQuestionResponseId(this.question.hspCategoryQuestionId);
    },
    stateResponseTextValue() {
      let responses = this.$store.getters.getQuestionResponses(this.question.hspCategoryQuestionId);

      if(responses.length) {
        return responses[0].responseTextValue;
      }

      return null;
    },
    hasResponseTriggers() {
      return this.question.responseTriggers.length > 0;
    },
    textModel: {
      get() {
        return this.stateResponseTextValue;
      },
      set(value) {
        this.handleTextChange(value);
      }
    }
  },
  methods: {
    displayError(error, description = "") {
      let display = error.length > 0 && error[0].length > 0;
      // console.log("In MultipleChoice.vue -- error:");
      // console.log(error);
      // console.log((description.length > 0 ? "for [" + description + "]: " : "") + "display = [" + display + "]");
      return display;
    },
    handleInput(value) {
      this.$store.dispatch('setQuestionResponse', {
        questionTypeId: this.question.hspQuestionTypeId,
        questionId: this.question.hspCategoryQuestionId,
        responseId: value
      });

      let response = this.question.responses.find(response => response.hspResponseId === value);
      if([2,3].indexOf(response.hspResponseTypeId) === -1) {
        this.textModel = null;
      }

      this.handleResponseTriggers(value);
      this.$refs.mcObserver.reset();
    },
    handleTextChange(value) {
      this.$store.dispatch('setQuestionResponse', {
        questionTypeId: this.question.hspQuestionTypeId,
        questionId: this.question.hspCategoryQuestionId,
        responseText: value
      });
    },
    handleResponseTriggers(value) {
      if(this.hasResponseTriggers) {
        let responseTrigger = this.question.responseTriggers.find(trigger => trigger.triggerResponseId === value);

        if(responseTrigger) {
          this.$store.dispatch('setTargetSection', responseTrigger);
        }
        else {
          this.$store.dispatch('clearTargetSectionId', this.sectionId);
          this.$emit('triggercleared');
        }
      }
    },
    disable(hspResponseId) {
      return hspResponseId !== this.stateResponseId;
    },
  },
  watch: {
    isDisplayed: function(value) {
      if(value === true) {
        this.handleResponseTriggers(this.stateResponseId);
      }
    }
  },
  created() {
    this.responses = getResponses(this.question);
  }
}
</script>
